import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { DatePipe } from '@angular/common'
import { ActivatedRoute } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'
import { CallsService } from '../calls.service'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'

type ExtendState = 'loading' | 'prompt' | 'extending' | 'extended' | 'not-extended' | 'error'

@Component({
  selector: 'app-extend-page',
  standalone: true,
  imports: [TranslatePipe, MatButtonModule, DatePipe],
  templateUrl: './extend-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './extend-page.component.scss',
})
export class ExtendPageComponent implements OnInit {
  route = inject(ActivatedRoute)
  callsService = inject(CallsService)
  translateService = inject(TranslateService)
  cdr = inject(ChangeDetectorRef)

  state: ExtendState = 'loading'
  leaveDate: string | null = null

  currentCallId = parseInt(this.route.snapshot.params['id'], 10)
  accessKey = this.route.snapshot.queryParams['access-key']

  ngOnInit(): void {
    this.translateService.use('en').subscribe()
    this.callsService.previewExtendCallAnonymously(this.currentCallId, this.accessKey).subscribe((preview) => {
      if (preview.status === 'EXTENDABLE') {
        this.leaveDate = preview.leaveDate
        this.state = 'prompt'
      } else if (preview.status === 'NOT_EXTENDABLE') {
        this.state = 'not-extended'
      } else {
        this.state = 'error'
      }
      this.cdr.detectChanges()
    })
  }

  confirmExtend(): void {
    this.state = 'extending'
    this.callsService.extendCallAnonymously(this.currentCallId, this.accessKey).subscribe((result) => {
      if (result.status === 'EXTENDED') {
        this.leaveDate = result.leaveDate
        this.state = 'extended'
      } else if (result.status === 'NOT_EXTENDED') {
        this.state = 'not-extended'
      } else {
        this.state = 'error'
      }
      this.cdr.detectChanges()
    })
  }
}
